"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var crud_actions_1 = __importDefault(require("./crud-actions"));
var crud_reducer_1 = __importDefault(require("./crud-reducer"));
var main_types_1 = require("./main-types");
var utils_1 = require("./utils");
function createModel(config) {
    var _a, _b;
    var HowMany = Symbol();
    var actions = crud_actions_1.default(config.actionTypes, config.keyOfId);
    var timestamps = utils_1.getDefaultTimeStamps(config.timestamps, config.dockeys);
    var crudReducer = crud_reducer_1.default(config.actionTypes, config.keyOfId);
    var empty = null;
    var ModelClass = (_b = /** @class */ (function () {
            function Model(args) {
                this[_a] = false;
                this[main_types_1.modelSymbols.initialDoc] = {};
                for (var _i = 0, _b = config.dockeys; _i < _b.length; _i++) {
                    var key = _b[_i];
                    this[main_types_1.modelSymbols.initialDoc][key] = args[key];
                    this[key] = args[key];
                }
            }
            Model.prototype.saveSync = function () {
                if (!this[config.keyOfId]) {
                    throw new Error("document must have " + config.keyOfId + " in order to be saved");
                }
                var instances = config.getInstances();
                if (instances) {
                    var instance = instances[this[config.keyOfId]];
                    if (instance) {
                        this.constructor.updateByDocSync(this.toObject());
                        return;
                    }
                }
                this.constructor.loadOneSync(this.toObject());
            };
            Model.prototype.toObject = function () {
                var obj = {};
                for (var _i = 0, _b = config.dockeys; _i < _b.length; _i++) {
                    var key = _b[_i];
                    obj[key] = this[key];
                }
                return obj;
            };
            Model.prototype.getLoadTime = function () {
                var instances = config.getInstances();
                if (instances) {
                    var instance = instances[this[config.keyOfId]];
                    if (instance) {
                        return typeof instance.loadTime === "string"
                            ? new Date(instance.loadTime)
                            : instance.loadTime;
                    }
                }
                return undefined;
            };
            Model.prototype.getFullDoc = function () {
                var instances = config.getInstances();
                if (instances) {
                    var instance = instances[this[config.keyOfId]];
                    return instance || empty;
                }
                return empty;
            };
            Model.initialize = function () {
                if (!config.loadInstancesFromStorage) {
                    throw new Error("loadInstancesFromStorage must be provided in order to call `initialize` method");
                }
                var info = config.loadInstancesFromStorage();
                if (info.data) {
                    this.loadManyFromStorageSync(info.data);
                }
                return info;
            };
            /* protected */ Model.addTimestampsToDoc = function (doc) {
                if (!timestamps ||
                    (!timestamps.createdAt && !timestamps.updatedAt)) {
                    return doc;
                }
                if (!timestamps.updatedAt && doc[timestamps.createdAt]) {
                    return doc;
                }
                var newDoc = __assign({}, doc);
                if (timestamps.createdAt && !newDoc[timestamps.createdAt]) {
                    newDoc[timestamps.createdAt] = new Date();
                }
                if (timestamps.updatedAt) {
                    newDoc[timestamps.updatedAt] = new Date();
                }
                return newDoc;
            };
            Model.findByIdSync = function (id, raw) {
                if (raw === void 0) { raw = null; }
                var instances = config.getInstances();
                if (!instances)
                    return empty;
                var instance = instances[id];
                if (!instance) {
                    return empty;
                }
                if (raw) {
                    return instance.info;
                }
                return new this(instance.info);
            };
            Model.findManyByIdsSync = function (ids, raw) {
                if (raw === void 0) { raw = null; }
                var instances = config.getInstances();
                if (!instances)
                    return [];
                var objs = [];
                var notFoundIds = [];
                for (var i = 0; i < ids.length; ++i) {
                    var id = ids[i];
                    if (instances[id]) {
                        objs.push(raw
                            ? instances[id].info
                            : new this(instances[id].info));
                    }
                    else {
                        notFoundIds.push(id);
                    }
                }
                return objs;
            };
            Model.findOneSync = function (query, options) {
                var searchResult = this.findManySync(query, options);
                if (searchResult.length === 0) {
                    return empty;
                }
                return searchResult[0];
            };
            Model.deleteOneSync = function (query) {
                var doc = this.findOneSync(query);
                if (!doc)
                    return;
                this.deleteByIdSync(doc[config.keyOfId]);
            };
            Model.findManySync = function (query, options) {
                var instances = config.getInstances();
                if (!instances) {
                    return [];
                }
                var idsOfInstances = Object.keys(instances);
                if (!instances || idsOfInstances.length === 0) {
                    return [];
                }
                if (query[config.keyOfId]) {
                    idsOfInstances = [query[config.keyOfId]];
                }
                else if (config.indices) {
                    var bestIndex = options && options.$hint;
                    if (!bestIndex) {
                        var best = {
                            searchCount: Infinity,
                            index: undefined,
                            indexIndex: -1,
                        };
                        var i = -1;
                        for (var _i = 0, _b = config.indices; _i < _b.length; _i++) {
                            var index = _b[_i];
                            ++i;
                            var indexHolder = this
                                .indicesTable[i];
                            var howManyToSearch = Infinity;
                            var j = 0;
                            for (; j < index.fields.length; ++j) {
                                var indexKey = index.fields[j];
                                if (indexHolder[HowMany] !== undefined) {
                                    howManyToSearch = indexHolder[HowMany];
                                }
                                else if (index.unique &&
                                    j === index.fields.length - 1) {
                                    howManyToSearch = 1;
                                }
                                if (query[indexKey] === undefined) {
                                    break;
                                }
                                if (indexHolder[query[indexKey]] ===
                                    undefined) {
                                    return [];
                                }
                                indexHolder = indexHolder[query[indexKey]];
                            }
                            if (howManyToSearch < best.searchCount) {
                                best.searchCount = howManyToSearch;
                                best.index = index;
                                best.indexIndex = i;
                            }
                        }
                        if (best.searchCount < Infinity && best.index) {
                            bestIndex = best.index;
                        }
                    }
                    if (bestIndex) {
                        var fields = bestIndex.fields;
                        var indexIndex = config.indices.indexOf(bestIndex);
                        if (indexIndex > -1) {
                            // console.log(best.index);
                            var indexHolder = this
                                .indicesTable[indexIndex];
                            // console.log(indexHolder);
                            var j = 0;
                            for (; j < fields.length; ++j) {
                                var indexKey = fields[j];
                                if (query[indexKey] === undefined) {
                                    break;
                                }
                                indexHolder = indexHolder[query[indexKey]];
                                // console.log(indexHolder);
                            }
                            if (j === fields.length) {
                                idsOfInstances = bestIndex.unique
                                    ? [indexHolder]
                                    : Object.keys(indexHolder);
                            }
                            else {
                                idsOfInstances = [];
                                var hei = [indexHolder];
                                var lastIndex = 0;
                                for (; j < fields.length; ++j) {
                                    var n = hei.length;
                                    for (; lastIndex < n; ++lastIndex) {
                                        var obj = hei[lastIndex];
                                        for (var key in obj) {
                                            hei.push(obj[key]);
                                        }
                                    }
                                }
                                for (; lastIndex < hei.length; ++lastIndex) {
                                    if (bestIndex.unique) {
                                        idsOfInstances.push(hei[lastIndex]);
                                    }
                                    else {
                                        for (var k in hei[lastIndex]) {
                                            idsOfInstances.push(k);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (idsOfInstances.length === 0)
                    return [];
                var objs = [];
                var fixedIds = {};
                for (var _c = 0, idsOfInstances_1 = idsOfInstances; _c < idsOfInstances_1.length; _c++) {
                    var id = idsOfInstances_1[_c];
                    if (fixedIds[id]) {
                        // console.trace(`duplicate detected for id ${id}`);
                        continue;
                    }
                    var obj = instances[id];
                    if (!obj)
                        continue;
                    var areEqual = true;
                    for (var q in query) {
                        if (obj.info[q] !== query[q]) {
                            areEqual = false;
                            break;
                        }
                    }
                    if (!areEqual)
                        continue;
                    fixedIds[id] = true;
                    var instance = new this(obj.info);
                    objs.push(instance);
                }
                if (options && options.$sort) {
                    if (typeof options.$sort === "function") {
                        objs.sort(options.$sort);
                    }
                    else {
                        objs.sort(utils_1.getDefaultSort(options.$sort));
                    }
                }
                return objs;
            };
            Model.updateManyByDocsSync = function (docs, extras, dispatchAction, instances) {
                var _b;
                if (dispatchAction === void 0) { dispatchAction = true; }
                if (!instances)
                    instances = config.getInstances();
                if (!instances)
                    return;
                var documents = [];
                for (var _i = 0, docs_1 = docs; _i < docs_1.length; _i++) {
                    var doc = docs_1[_i];
                    var oldInstance = empty;
                    var document_1 = timestamps && timestamps.updatedAt
                        ? __assign(__assign({}, doc), (_b = {}, _b[timestamps.updatedAt] = new Date(), _b)) : doc;
                    if (instances && instances[doc[config.keyOfId]]) {
                        oldInstance = instances[document_1[config.keyOfId]].info;
                        this.updateIndices(oldInstance, false);
                    }
                    if (oldInstance) {
                        this.updateIndices(__assign(__assign({}, oldInstance), document_1), true);
                    }
                    documents.push(document_1);
                }
                if (dispatchAction) {
                    this.dispatch(this.syncronousCrudActions.updateMany(documents, extras));
                }
            };
            Model.updateManySync = function (query, newDoc, raw) {
                var documents = this.findManySync(query);
                var docs = [];
                for (var _i = 0, documents_1 = documents; _i < documents_1.length; _i++) {
                    var doc = documents_1[_i];
                    for (var key in newDoc) {
                        doc[key] = newDoc[key];
                    }
                }
                var rawDocs = docs.map(function (e) { return e.toObject(); });
                this.updateManyByDocsSync(rawDocs);
                if (raw)
                    return rawDocs;
                return docs;
            };
            Model.updateOneSync = function (query, newDoc, raw) {
                var document = this.findOneSync(query);
                if (!document) {
                    return null;
                }
                for (var key in newDoc) {
                    document[key] = newDoc[key];
                }
                document.saveSync();
                if (raw) {
                    return document.toObject();
                }
                return document;
            };
            Model.deleteManyByIdsSync = function (ids, dispatchAction) {
                if (dispatchAction === void 0) { dispatchAction = true; }
                var documents = this.findManyByIdsSync(ids, "raw");
                for (var _i = 0, documents_2 = documents; _i < documents_2.length; _i++) {
                    var doc = documents_2[_i];
                    this.updateIndices(doc, false);
                }
                if (dispatchAction) {
                    this.dispatch(this.syncronousCrudActions.deleteMany(documents.map(function (e) { return e[config.keyOfId]; })));
                }
            };
            Model.deleteManySync = function (query, options) {
                var docs = this.findManySync(query, options);
                if (!docs.length)
                    return;
                this.deleteManyByIdsSync(docs.map(function (e) { return e[config.keyOfId]; }));
            };
            Model.getStoreRawInstancesObj = function () {
                var instances = config.getInstances();
                return instances;
            };
            Model.getRawInstancesObj = function () {
                var instances = config.getInstances();
                var rawInstances = {};
                for (var instanceId in instances) {
                    rawInstances[instanceId] = instances[instanceId].info;
                }
                return rawInstances;
            };
            Model.getAllSync = function (raw) {
                if (raw === void 0) { raw = null; }
                var instances = config.getInstances();
                if (!instances)
                    return [];
                var objs = [];
                for (var instanceId in instances) {
                    var instance = raw
                        ? instances[instanceId].info
                        : new this(instances[instanceId].info);
                    objs.push(instance);
                }
                return objs;
            };
            Model.subscribeChangeById = function (id, cb) {
                var _this = this;
                var lastInstances = config.getInstances();
                var lastInstance = lastInstances && lastInstances[id] && lastInstances[id].info;
                return this.subscribeStoreChange(function () {
                    var currentInstances = config.getInstances();
                    if (currentInstances === lastInstances)
                        return;
                    var currentInstance = currentInstances &&
                        currentInstances[id] &&
                        currentInstances[id].info;
                    if (lastInstance !== currentInstance) {
                        lastInstance = currentInstance;
                        lastInstances = currentInstances;
                        cb(currentInstance ? new _this(currentInstance) : empty);
                    }
                });
            };
            Model.subscribeOneDocChangeByQuery = function (query, options, cb) {
                var _this = this;
                var lastInstances = config.getInstances();
                var getRaw = !!options && !!options.raw;
                var newOptions = __assign(__assign({}, (options || {})), { raw: true });
                var lastInstance = this.findOneSync(query, newOptions);
                return this.subscribeStoreChange(function () {
                    var currentInstances = config.getInstances();
                    if (currentInstances === lastInstances)
                        return;
                    if (!currentInstances) {
                        if (lastInstance) {
                            cb(empty);
                        }
                        return;
                    }
                    var currentInstance = _this.findOneSync(query, newOptions);
                    if (lastInstance !== currentInstance) {
                        lastInstance = currentInstance;
                        lastInstances = currentInstances;
                        cb(currentInstance
                            ? getRaw
                                ? currentInstance
                                : new _this(currentInstance)
                            : empty);
                    }
                });
            };
            Model.subscribeManyDocsChangeByQuery = function (query, options, cb) {
                var _this = this;
                var getRaw = !!options && !!options.raw;
                var newOptions = __assign(__assign({}, (options || {})), { raw: true });
                var lastInstances = config.getInstances();
                var lastFoundInstances = this.findManySync(query, newOptions);
                return this.subscribeStoreChange(function () {
                    var currentInstances = config.getInstances();
                    if (currentInstances === lastInstances)
                        return;
                    var currentFoundInstances = _this.findManySync(query, newOptions);
                    var areSame = lastFoundInstances.length === currentFoundInstances.length;
                    if (areSame) {
                        for (var i = 0; i < lastFoundInstances.length; i++) {
                            if (lastFoundInstances[i] !== currentFoundInstances[i]) {
                                areSame = false;
                                break;
                            }
                        }
                    }
                    if (!areSame) {
                        lastFoundInstances = currentFoundInstances;
                        lastInstances = currentInstances;
                        cb(getRaw
                            ? currentFoundInstances
                            : currentFoundInstances.map(function (e) { return new _this(e); }));
                    }
                });
            };
            Model.subscribeManyDocsChangeByIds = function (ids, raw, cb) {
                var _this = this;
                var lastInstances = config.getInstances();
                var lastFoundInstances = this.findManyByIdsSync(ids, "raw");
                return this.subscribeStoreChange(function () {
                    var currentInstances = config.getInstances();
                    if (currentInstances === lastInstances)
                        return;
                    var currentFoundInstances = _this.findManyByIdsSync(ids, "raw");
                    var areSame = lastFoundInstances.length === currentFoundInstances.length;
                    if (areSame) {
                        for (var i = 0; i < lastFoundInstances.length; i++) {
                            if (lastFoundInstances[i] !== currentFoundInstances[i]) {
                                areSame = false;
                                break;
                            }
                        }
                    }
                    if (!areSame) {
                        lastFoundInstances = currentFoundInstances;
                        lastInstances = currentInstances;
                        cb(raw
                            ? currentFoundInstances
                            : currentFoundInstances.map(function (e) { return new _this(e); }));
                    }
                });
            };
            Model.subscribeChange = function (cb) {
                var lastInstances = config.getInstances();
                return this.subscribeStoreChange(function () {
                    var currentInstances = config.getInstances();
                    if (currentInstances === lastInstances)
                        return;
                    lastInstances = currentInstances;
                    cb();
                });
            };
            Model.updateByDocSync = function (doc, extra, dispatchAction, instances) {
                var _b;
                if (dispatchAction === void 0) { dispatchAction = true; }
                if (!instances)
                    instances = config.getInstances();
                var document = timestamps && timestamps.updatedAt
                    ? __assign(__assign({}, doc), (_b = {}, _b[timestamps.updatedAt] = new Date(), _b)) : doc;
                var oldInstance = empty;
                if (instances && instances[document[config.keyOfId]]) {
                    oldInstance = instances[document[config.keyOfId]].info;
                    this.updateIndices(oldInstance, false);
                }
                if (oldInstance) {
                    this.updateIndices(__assign(__assign({}, oldInstance), document), true);
                }
                if (dispatchAction) {
                    this.dispatch(this.syncronousCrudActions.updateOne(document, extra));
                }
            };
            Model.clearAllSync = function (dispatchAction) {
                if (dispatchAction === void 0) { dispatchAction = true; }
                this.clearIndices();
                if (dispatchAction) {
                    this.dispatch(this.syncronousCrudActions.clearAll());
                }
            };
            Model.deleteByIdSync = function (id, dispatchAction, instances) {
                if (dispatchAction === void 0) { dispatchAction = true; }
                if (!instances)
                    instances = config.getInstances();
                if (instances && instances[id]) {
                    this.updateIndices(instances[id].info, false);
                }
                if (dispatchAction) {
                    this.dispatch(this.syncronousCrudActions.deleteOne(id));
                }
            };
            Model.loadOneSync = function (doc, loadTime, extra, raw, dispatchAction, instances) {
                if (raw === void 0) { raw = null; }
                if (dispatchAction === void 0) { dispatchAction = true; }
                if (!instances)
                    instances = config.getInstances();
                var exists = false;
                if (instances && instances[doc[config.keyOfId]]) {
                    exists = true;
                }
                var document = this.addTimestampsToDoc(doc);
                if (exists) {
                    this.updateByDocSync(document, extra, false, instances);
                }
                else {
                    this.updateIndices(document, true);
                }
                if (dispatchAction) {
                    this.dispatch(this.syncronousCrudActions.loadOne(document, loadTime, extra));
                }
                if (raw)
                    return document;
                return new this(document);
            };
            Model.loadManySync = function (docs, clearOthers, loadTime, extras, raw, dispatchAction, instances) {
                if (dispatchAction === void 0) { dispatchAction = true; }
                var docIds = null;
                if (clearOthers === "replaceAll") {
                    this.clearAllSync(false);
                }
                else if (Array.isArray(clearOthers)) {
                    docIds = clearOthers;
                }
                else if (clearOthers) {
                    var docsToDelete = this.findManySync(clearOthers, {
                        raw: true,
                    });
                    docIds = docsToDelete.map(function (e) { return e[config.keyOfId]; });
                }
                if (docIds) {
                    this.deleteManyByIdsSync(docIds, false);
                }
                var docsuments = [];
                for (var i = 0; i < docs.length; ++i) {
                    var doc = this.loadOneSync(docs[i], loadTime, extras ? extras[i] : undefined, raw, false, instances);
                    docsuments.push(doc);
                }
                if (dispatchAction) {
                    this.dispatch(this.syncronousCrudActions.loadMany(docs, !clearOthers || clearOthers === "replaceAll"
                        ? clearOthers
                        : docIds, loadTime, extras));
                }
                return docsuments;
            };
            Model.loadManyFromStorageSync = function (obj) {
                if (!obj)
                    return;
                var docs = [];
                var extras = [];
                for (var key in obj) {
                    var _b = obj[key], info = _b.info, rest = __rest(_b, ["info"]);
                    docs.push(info);
                    extras.push(rest);
                    this.updateIndices(info, true);
                }
                this.dispatch(this.syncronousCrudActions.loadMany(docs, null, undefined, extras));
                return;
            };
            Model.reducer = function (state, action, isExternalAction) {
                var newState = crudReducer(state, action);
                if (!isExternalAction)
                    return newState;
                var actionType = action.type;
                if (actionType === config.actionTypes.loadOne) {
                    var loadOneAction = action;
                    this.loadOneSync(loadOneAction.info, loadOneAction.loadTime, loadOneAction.extra, null, false, state || {});
                }
                else if (actionType === config.actionTypes.loadMany) {
                    var loadManyAction = action;
                    this.loadManySync(loadManyAction.infos, loadManyAction.clearOthers, loadManyAction.loadTime, loadManyAction.extras, null, false, state || {});
                }
                else if (actionType === config.actionTypes.deleteOne) {
                    var deleteAction = action;
                    this.deleteByIdSync(deleteAction[config.keyOfId], false, state || {});
                }
                else if (actionType === config.actionTypes.deleteMany) {
                    var deleteAction = action;
                    this.deleteManyByIdsSync(deleteAction.ids, false);
                }
                else if (actionType === config.actionTypes.clearAll) {
                    this.clearAllSync(false);
                }
                else if (actionType === config.actionTypes.updateOne) {
                    var updateAction = action;
                    this.updateByDocSync(updateAction.info, updateAction.extra, false, state || {});
                }
                else if (actionType === config.actionTypes.updateMany) {
                    var updateAction = action;
                    this.updateManyByDocsSync(updateAction.infos, updateAction.extras, false, state || {});
                }
                return newState;
            };
            Model.clearIndices = function () {
                for (var i = 0; i < this.indicesTable.length; ++i) {
                    this.indicesTable[i] = {};
                }
            };
            Model.updateIndices = function (doc, isLoaded // else deleted
            ) {
                if (!config.indices)
                    return;
                var i = -1;
                for (var _i = 0, _b = config.indices; _i < _b.length; _i++) {
                    var index = _b[_i];
                    ++i;
                    var indexHolder = this.indicesTable[i];
                    var HowManyIncrement = 0;
                    for (var j_1 = 0; j_1 < index.fields.length; ++j_1) {
                        var indexKey = index.fields[j_1];
                        if (doc[indexKey] === undefined)
                            return;
                        var newIndexHolder = indexHolder[doc[indexKey]];
                        if (!isLoaded) {
                            if (newIndexHolder === undefined)
                                return;
                        }
                        else {
                            if (!indexHolder[doc[indexKey]] &&
                                (!index.unique || j_1 < index.fields.length - 1)) {
                                indexHolder[doc[indexKey]] = {};
                            }
                            newIndexHolder = indexHolder[doc[indexKey]];
                        }
                        if (j_1 < index.fields.length - 1) {
                            indexHolder = newIndexHolder;
                        }
                        else {
                            if (isLoaded) {
                                if (index.unique) {
                                    if (!indexHolder[doc[indexKey]]) {
                                        HowManyIncrement++;
                                    }
                                    indexHolder[doc[indexKey]] =
                                        doc[config.keyOfId];
                                }
                                else {
                                    if (!indexHolder[doc[indexKey]][doc[config.keyOfId]]) {
                                        HowManyIncrement++;
                                    }
                                    indexHolder[doc[indexKey]][doc[config.keyOfId]] = true;
                                }
                            }
                            else {
                                if (index.unique) {
                                    if (indexHolder[doc[indexKey]]) {
                                        HowManyIncrement--;
                                        delete indexHolder[doc[indexKey]];
                                    }
                                }
                                else {
                                    if (indexHolder[doc[indexKey]][doc[config.keyOfId]]) {
                                        HowManyIncrement--;
                                        delete indexHolder[doc[indexKey]][doc[config.keyOfId]];
                                    }
                                }
                            }
                        }
                    }
                    indexHolder = this.indicesTable[i];
                    var j = 0;
                    for (; j < index.fields.length; ++j) {
                        var indexKey = index.fields[j];
                        if (!index.unique || j !== index.fields.length) {
                            indexHolder[HowMany] =
                                (indexHolder[HowMany] || 0) +
                                    HowManyIncrement;
                        }
                        var oldCount = index.unique && j === index.fields.length - 1
                            ? indexHolder[doc[indexKey]]
                                ? 1
                                : 0
                            : indexHolder[doc[indexKey]][HowMany] || 0;
                        if (!isLoaded && oldCount + HowManyIncrement === 0) {
                            delete indexHolder[doc[indexKey]];
                            break;
                        }
                        indexHolder = indexHolder[doc[indexKey]];
                    }
                    if (!index.unique && indexHolder && j === index.fields.length) {
                        indexHolder[HowMany] =
                            (indexHolder[HowMany] || 0) + HowManyIncrement;
                    }
                }
            };
            return Model;
        }()),
        main_types_1.modelSymbols.initialDoc,
        _a = main_types_1.modelSymbols.isDeleted,
        main_types_1.modelSymbols.IdKey,
        main_types_1.modelSymbols.IdType,
        main_types_1.modelSymbols.DocType,
        /* protected */ _b.dispatch = config.dispatch,
        /* protected */ _b.subscribeStoreChange = config.subscribe,
        /* protected */ _b.syncronousCrudActions = actions,
        /* protected */ _b.dockeys = config.dockeys,
        _b.indicesTable = !config.indices
            ? []
            : config.indices.map(function () { return ({}); }),
        _b);
    return ModelClass;
}
exports.createModel = createModel;
